import useApi from '../hook/useApi';

const useUsersApi = () => {
    const { sendRequest, loading, data, error } = useApi();

    const getUsers = async (page = 1, search = "", status = "", subscription = "", searchFilter = "", isLoginFailed = false) => {
        let queryParams = [`page=${page}`, `limit=10`];

        if (search) {
            queryParams.push(`search=${encodeURIComponent(search)}`);
        }

        if (searchFilter !== "") {
            queryParams.push(`search_filter=${searchFilter}`);
        }

        if (status !== "") {
            queryParams.push(`is_live=${status}`);
        }

        if (subscription !== "" && subscription !== "login_failed") {
            queryParams.push(`filter=${subscription}`);
        }

        if (isLoginFailed) {
            queryParams.push(`is_login_failed_users=true`);
        }

        const queryString = queryParams.join('&');
        return sendRequest(`/imp/user_screen/get_user_list?${queryString}`, 'GET', {});
    };

    const getUser = async (id) => {
        return sendRequest(`/imp/user_screen/get_user_object_by_id/${id}`, 'GET', {});
    };

    const getUserStates = async (filter, start_date, end_date) => {
        const queryParams = new URLSearchParams();
        if (filter) {
            queryParams.append('filter', filter.filter);
        }
        if (filter.start_date) queryParams.append('start_date', filter.start_date);
        if (filter.end_date) queryParams.append('end_date', filter.end_date);

        const url = `/imp/user_screen/get_calculatedinfo?${queryParams.toString()}`;
        return sendRequest(url, 'GET');
    };


    const verifyDocuments = async (payload) => {
        return sendRequest('/imp/documents_screen/verify_user_documents', 'PUT', payload);
    };

    const startTimeTracking = async (payload) => {
        const authToken = localStorage.getItem('authToken');
        return sendRequest(`/imp/time_tracking/start?authToken=${authToken}`, 'POST', payload);
    };
    const endTimeTracking = async (payload) => {
        const authToken = localStorage.getItem('authToken');
        return sendRequest(`/imp/time_tracking/end?authToken=${authToken}`, 'POST', payload);
    };

    const getDashboardStates = async (params) => {
        const queryParams = Object.entries(params)
            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
            .join('&');
        return sendRequest(`/imp/dashboard_screen/get_calculatedinfo?${queryParams}`, 'GET', {});
    };

    const editUserStatus = async (payload) => {
        return sendRequest('/imp/user_screen/edit_users_accountstatus_and_dutystatus', 'POST', payload);
    };

    const editVehicleSelectionBySuperAdmin = async (payload) => {
        return sendRequest('/imp/user_screen/edit_vehicle_selection_by_superadmin', 'POST', payload);
    };

    const changeParentUser = async (payload) => {
        return sendRequest('/imp/user_screen/change_parent_user_id_of_user', 'POST', payload);
    };

    const makeCall = async (phone_number) => {
        return sendRequest('/imp/app_side/click_to_call_and_send_notification_to_admin_apk', 'POST', { phone_number });
    };

    const sendWhatsAppNotification = async (phone_number) => {
        return sendRequest('/imp/app_side/click_to_wts_btn_and_send_notification_to_admin_apk', 'POST', { phone_number });
    };

    const getUserActivityHistory = async (user_id, page = 1, limit = 10, start_date = '', end_date = '') => {
        const params = new URLSearchParams({ page, limit, user_id });
        if (start_date) params.append('start_date', start_date);
        if (end_date) params.append('end_date', end_date);
        return sendRequest(`/imp/user_screen/get_user_apk_usage_history?${params.toString()}`, 'GET', {});
    };

    const getWalletBalanceAndHistory = async (user_id, page = 1, limit = 10) => {
        const params = new URLSearchParams({ page, limit, user_id });
        return sendRequest(`/imp/user_screen/get_wallet_balance_and_history?${params.toString()}`, 'GET', {});
    };

    const getDriverCallHistory = async (user_id, page = 1, limit = 10) => {
        const params = new URLSearchParams({ page, limit, user_id });
        return sendRequest(`/imp/user_screen/get_driver_call_history_from_bookings?${params.toString()}`, 'GET', {});
    };

    const getAdminCallHistory = async (user_id, page = 1, limit = 10) => {
        const params = new URLSearchParams({ page, limit, user_id });
        return sendRequest(`/imp/user_screen/get_driver_call_history_from_admin_phone_calls?${params.toString()}`, 'GET', {});
    };

    return {
        getUsers,
        getUser,
        getUserStates,
        verifyDocuments,
        startTimeTracking,
        endTimeTracking,
        getDashboardStates,
        editUserStatus,
        editVehicleSelectionBySuperAdmin,
        changeParentUser,
        makeCall,
        sendWhatsAppNotification,
        getUserActivityHistory,
        getWalletBalanceAndHistory,
        getDriverCallHistory,
        getAdminCallHistory,
        loading,
        data,
        error,
    };
};

export default useUsersApi;